import {
   VisitDraftPrescriptionsQuantityQuery,
   VisitPrescriptionListDraftUpdateCommand,
} from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { RecipientCategory, SentPrescriptionPackage } from '~libs.shared.prescription';

import { VisitId } from '../../PrescriptionIssuingPanel.types';
import { draftPrescriptionsTranslationKeys } from '../../../../translations';

import { DraftPrescriptionsFormBean } from './DraftPrescriptionsForm.types';
import { createListDraftPrescriptionDTO } from './DraftPrescriptionsForm.utils';

type VisitPrescriptionListDraftUpdateCommandParameters = {
   visitId: VisitId;
   sentPrescriptionPackages: SentPrescriptionPackage[];
   draftPrescriptions: DraftPrescriptionsFormBean['draftPrescriptions'];
   prescriptionCategory: RecipientCategory;
};

export const useVisitPrescriptionListDraftUpdateCommand = (): UseCqrsCommandResult<
   void,
   VisitPrescriptionListDraftUpdateCommandParameters
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new VisitPrescriptionListDraftUpdateCommand();
         command.prescriptions = createListDraftPrescriptionDTO({
            sentPrescriptionPackages: parameters.sentPrescriptionPackages,
            draftPrescriptions: parameters.draftPrescriptions,
         });
         command.recipientCategory = Choice.of(parameters.prescriptionCategory);
         command.visitId = parameters.visitId;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(VisitDraftPrescriptionsQuantityQuery);
         },
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(draftPrescriptionsTranslationKeys.cannotSaveDraftPrescriptions);
         },
      }
   );
};
